import { Table, Column, Data, FieldType, FieldValue, Section } from "../../../../../features/ui"
import { Labels } from "../../../../../features/data-types"
import { MeasureType } from "../../../state/types"
import { useUnitTypeHooks } from "../../../../stock"

type Props = {
    title: string
    rows: Data[]
    disableCreate?: boolean
    readOnly?: boolean
    collapsable?: boolean
    space?: number
    onCreate?: () => void
    onEditRow?: (measureType: string) => void
    onRemoveRow?: (measureType: string) => void
}

export const MeasuresTable = (props: Props) => {
    const { title, rows, disableCreate, readOnly, collapsable, space = 12, onCreate, onEditRow, onRemoveRow } = props

    const { describeContent } = useUnitTypeHooks()

    const columns: Column[] = [
        {
            name: 'measureType',
            type: FieldType.TEXT,
            label: '',
            render: (value?: FieldValue) => Labels.measureTypeLabel(value! as MeasureType)
        },
        {
            name: 'measureUnits',
            type: FieldType.TEXT,
            label: ''
        }
    ]

    const measureRows = rows.map(row => {
        const { type, units, unitTypeId } = row
        return {
            measureType: type,
            measureUnits: describeContent(units! as number, unitTypeId! as string)
        }
    })

    return (
        <Section
            id='measures'
            title={title}
            space={space}
            collapsable={collapsable}
            defaultExpanded
        >
            <Table
                columns={columns}
                rows={measureRows}
                rowId='measureType'
                disableCreate={disableCreate}
                readOnly={readOnly}
                createIcon="plus"
                small
                onCreate={onCreate}
                onEdit={onEditRow}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}
